<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { FormCreator, ButtonAll, FieldCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    contractId: { type: Number, required: true },
    contact: { type: String, required: true },
    formData: {},
  },

  data() {
    return {
      sending: false,
      loadForm: false,
      loadField: false,
    }
  },

  computed: {
    isSalesman() {
      return this.contact === 'salesman'
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ build }) {
      if (build) {
        this.loadField = build
      }
    },
    isSending(sending) {
      this.sending = sending
    },
    openModal() {
      this.loadForm = true
      this.$refs.modalContact.open()
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs.modalContact.close(false)
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-contact"
    ref="modalContact"
    class-modal-dialog="modal-lg"
    :title-t="'contract.client.popin.contact.' + contact"
    @icon-close="closeModal"
    e2e-modal="contact"
  >
    <template #body>
      <FieldCreator v-if="loadField && isSalesman" :form-data="formData" form-ref="formcontact" name="salesman" />
      <FieldCreator
        v-if="loadField && !isSalesman"
        :form-data="formData"
        form-ref="formcontact"
        name="billingContacts"
        select-multiple
      />
    </template>
    <template #footer>
      <ButtonAll type="information" margin="no" @click="closeModal" label="button.cancel" />
      <FormCreator
        @update-data="updateData"
        v-if="loadForm"
        ref="formcontact"
        endpoint="contracts"
        method="patch"
        :id="contractId"
        specific-endpoint="updateContact"
        class-to-add="btn-lg"
        @is-sending="isSending"
        @global-build="globalBuild"
      >
        <div v-if="sending" class="text-center">
          <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else>
          {{ $t('contract.client.popin.contact.send') }}
        </div>
      </FormCreator>
    </template>
  </ModalDialog>
</template>
